export const initialProducts = {
  cakes: {
    chocolate: [
      {
        id: 1,
        name: "Classic Chocolate Cake",
        description: "Rich, moist chocolate layers with creamy chocolate ganache",
        category: "Cake",
        subCategory: "Chocolate",
        image: "https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=500&h=500&fit=crop",
        sizes: [
          { size: "0.5kg", price: 450 },
          { size: "1kg", price: 850 },
          { size: "2kg", price: 1600 }
        ],
        featured: true
      },
      {
        id: 2,
        name: "Dark Chocolate Truffle",
        description: "Decadent dark chocolate with truffle filling",
        category: "Cake",
        subCategory: "Chocolate",
        image: "https://images.unsplash.com/photo-1606890737304-57a1ca8a5b62?w=500&h=500&fit=crop",
        sizes: [
          { size: "0.5kg", price: 550 },
          { size: "1kg", price: 1050 },
          { size: "2kg", price: 2000 }
        ],
        featured: true
      },
      {
        id: 3,
        name: "Chocolate Fudge Cake",
        description: "Ultra-rich fudgy chocolate cake with chocolate chips",
        category: "Cake",
        subCategory: "Chocolate",
        image: "https://images.unsplash.com/photo-1586985289565-f7a4e1c2e8b7?w=500&h=500&fit=crop",
        sizes: [
          { size: "0.5kg", price: 500 },
          { size: "1kg", price: 950 },
          { size: "2kg", price: 1800 }
        ],
        featured: false
      }
    ],
    pineapple: [
      {
        id: 4,
        name: "Fresh Pineapple Cake",
        description: "Light and fluffy cake with fresh pineapple chunks",
        category: "Cake",
        subCategory: "Pineapple",
        image: "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=500&h=500&fit=crop",
        sizes: [
          { size: "0.5kg", price: 400 },
          { size: "1kg", price: 750 },
          { size: "2kg", price: 1400 }
        ],
        featured: true
      },
      {
        id: 5,
        name: "Pineapple Upside Down Cake",
        description: "Classic upside down cake with caramelized pineapple",
        category: "Cake",
        subCategory: "Pineapple",
        image: "https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=500&h=500&fit=crop",
        sizes: [
          { size: "0.5kg", price: 450 },
          { size: "1kg", price: 850 },
          { size: "2kg", price: 1600 }
        ],
        featured: true
      },
      {
        id: 6,
        name: "Tropical Pineapple Delight",
        description: "Pineapple cake with coconut cream frosting",
        category: "Cake",
        subCategory: "Pineapple",
        image: "https://images.unsplash.com/photo-1621303837174-89787a7d4729?w=500&h=500&fit=crop",
        sizes: [
          { size: "0.5kg", price: 480 },
          { size: "1kg", price: 900 },
          { size: "2kg", price: 1700 }
        ],
        featured: false
      }
    ],
    customized: [
      {
        id: 7,
        name: "Photo Cake",
        description: "Personalized cake with edible photo print of your choice",
        category: "Cake",
        subCategory: "Customized",
        image: "https://images.unsplash.com/photo-1562440499-64c9a111f713?w=500&h=500&fit=crop",
        sizes: [
          { size: "0.5kg", price: 600 },
          { size: "1kg", price: 1100 },
          { size: "2kg", price: 2100 }
        ],
        featured: true
      },
      {
        id: 8,
        name: "Theme Birthday Cake",
        description: "Custom designed cake for any theme or occasion",
        category: "Cake",
        subCategory: "Customized",
        image: "https://images.unsplash.com/photo-1535141192574-5d4897c12636?w=500&h=500&fit=crop",
        sizes: [
          { size: "1kg", price: 1200 },
          { size: "2kg", price: 2300 },
          { size: "3kg", price: 3400 }
        ],
        featured: true
      },
      {
        id: 9,
        name: "Number/Letter Cake",
        description: "Custom shaped cake in any number or letter",
        category: "Cake",
        subCategory: "Customized",
        image: "https://images.unsplash.com/photo-1586985289688-ca3cf47d3e6e?w=500&h=500&fit=crop",
        sizes: [
          { size: "1.5kg", price: 1400 },
          { size: "2.5kg", price: 2600 },
          { size: "3.5kg", price: 3800 }
        ],
        featured: false
      },
      {
        id: 10,
        name: "3D Sculpted Cake",
        description: "Elaborate 3D cake sculpted to your design",
        category: "Cake",
        subCategory: "Customized",
        image: "https://images.unsplash.com/photo-1558636508-e0db3814bd1d?w=500&h=500&fit=crop",
        sizes: [
          { size: "2kg", price: 2500 },
          { size: "3kg", price: 3700 },
          { size: "4kg", price: 4900 }
        ],
        featured: true
      }
    ]
  },
  jarCakes: [
    {
      id: 11,
      name: "Chocolate Jar Cake",
      description: "Layers of chocolate cake, mousse, and ganache in a jar",
      category: "Jar Cake",
      image: "https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=500&h=500&fit=crop",
      sizes: [
        { size: "Single Jar", price: 150 },
        { size: "Pack of 4", price: 550 }
      ],
      featured: true
    },
    {
      id: 12,
      name: "Red Velvet Jar",
      description: "Red velvet cake layers with cream cheese in a portable jar",
      category: "Jar Cake",
      image: "https://images.unsplash.com/photo-1488477181946-6428a0291777?w=500&h=500&fit=crop",
      sizes: [
        { size: "Single Jar", price: 180 },
        { size: "Pack of 4", price: 650 }
      ],
      featured: true
    },
    {
      id: 13,
      name: "Oreo Jar Delight",
      description: "Crushed oreos with vanilla cream and chocolate layers",
      category: "Jar Cake",
      image: "https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=500&h=500&fit=crop",
      sizes: [
        { size: "Single Jar", price: 160 },
        { size: "Pack of 4", price: 600 }
      ],
      featured: false
    }
  ],
  brownies: [
    {
      id: 14,
      name: "Fudgy Chocolate Brownie",
      description: "Ultra-fudgy brownies with a crispy top and gooey center",
      category: "Brownie",
      image: "https://images.unsplash.com/photo-1606313564200-e75d5e30476c?w=500&h=500&fit=crop",
      sizes: [
        { size: "4 pieces", price: 200 },
        { size: "8 pieces", price: 380 },
        { size: "12 pieces", price: 550 }
      ],
      featured: true
    },
    {
      id: 15,
      name: "Walnut Brownie",
      description: "Rich chocolate brownies loaded with crunchy walnuts",
      category: "Brownie",
      image: "https://images.unsplash.com/photo-1590080876953-2db450cc684f?w=500&h=500&fit=crop",
      sizes: [
        { size: "4 pieces", price: 250 },
        { size: "8 pieces", price: 480 },
        { size: "12 pieces", price: 700 }
      ],
      featured: true
    },
    {
      id: 16,
      name: "Caramel Swirl Brownie",
      description: "Decadent brownies with swirls of salted caramel",
      category: "Brownie",
      image: "https://images.unsplash.com/photo-1515037893149-de7f840978e2?w=500&h=500&fit=crop",
      sizes: [
        { size: "4 pieces", price: 280 },
        { size: "8 pieces", price: 530 },
        { size: "12 pieces", price: 780 }
      ],
      featured: false
    }
  ]
};